import { Observable } from 'rxjs';
import { Spend } from './model';

export abstract class SpendRepository {
  abstract createSpend(spend: Partial<Spend>): Observable<Spend>;
  abstract getSpend(id: number): Observable<Spend>;
  abstract getSpends(page: number, limit: number): Observable<Spend[]>;
  abstract updateSpend(id: number, spend: Partial<Spend>): Observable<Spend>;
  abstract deleteSpend(id: number): Observable<void>;
}
